import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hug a developer",
  "description": "",
  "published": "2008-09-12T00:00:00.000Z",
  "redirect_from": ["/blog/hug-a-developer/swizec/72"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Everything the video`}<em parentName="p">{` Hug a developer`}</em>{` says is true - there probably isn't a job more difficult than being a developer, at least no intellectual job can be much more difficult. Yes we're like gods to other less perfect beings and yes we do appear omnipotent and like we know everything, but the fact of the matter is our lives are hard.`}</p>
    <p>{`Most of what makes our lives hard are ignorant bosses who know next to nothing about our work seeming as how it's simply not very much like any other type of office work out there whereas they seem to think it is. People just don't understand that developing takes time, they think it's like writing a text, simpler perhaps, and no matter how often you tell them that you need to at least know what the hell it is you're supposed to do before doing it and preferably before running out of time, they will still change specs whenever they please. Somehow bosses just can't seem to comprehend the fact that changing a line or two in a large specification doesn't take changing a line or two in the code, but could actually mean weeks more work.`}</p>
    <p>{`But after all, I would rather work for three ignorant bosses who couldn't understand even each other at once than see my girlfriend in such a state as I saw her this morning ... it did however make me feel very powerful and like a god amongst the masses.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      